import React from 'react'
import {
  CamaraContainer,
  CamaraSubtitleText,
  ImageToShow,
  OpacityLayer,
  OverLayer,
} from './cameracard.styles'
import { ReactComponent as CamaraIcon } from '@/assets/icons/camara_outline_icon.svg'
import { Button, Text } from '@ui/components'
import { t } from 'i18next'
import { View, TouchableOpacity } from 'react-native'
import ImageAutoScale from '@/components/autoscaleimage'
// import { ReactComponent as PawIcon } from '@/assets/icons/paw.svg'
import { BodyText, colors, Headline5, ModalHeader } from '@/aena/styles'
import { ModalContainer } from '@/aena/styles'
import { ReactComponent as XSimpleIcon } from '@/assets/icons/x_simple_grey.svg'
import Modal from 'react-native-modal'
import { ReactComponent as EyeIcon } from '@/assets/icons/eye.svg'

export enum ImageTypeSelector {
  CHIP = 'CHIP',
  PASSPORT = 'PASSPORT',
  VACCINE = 'VACCINE',
  EDIT_PET = 'EDIT_PET',
}
export interface CamaraCardProps {
  title: string
  subtitle: string
  onGalleryPress?: (file: File, preview: string, type: ImageTypeSelector) => void
  url?: string
  type: ImageTypeSelector
}

export const CamaraCard: React.FC<CamaraCardProps> = ({ title, subtitle, onGalleryPress, url, type }) => {

  const [showModal, setShowModal] = React.useState<boolean>(false)
  const inputRef = React.useRef<HTMLInputElement>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()

        // Cuando el archivo se haya leído correctamente, actualiza el estado con la URL de la imagen
        reader.onloadend = () => {
          if (reader.result) {
            onGalleryPress?.(file, reader.result.toString(), type)
          }
        }

        reader.readAsDataURL(file) // Lee el archivo como URL de datos
      }
    }
  }

  const hasImage = !!url
  const handlePreviewPress = () => {
    setShowModal(!showModal)
  }

  return (
    <>

        <View style={{ flexDirection: 'row', gap: 16 }}>
          <View style={{ flex: 1, borderRadius: 10 }}>
          <CamaraContainer
        onPress={() => {
          inputRef.current?.click()
        }}
        style={{backgroundColor: '#f8f8f8', borderRadius: 10}}
      >
            <ImageToShow borderRadius={10} resizeMode="cover" source={{ uri: url }}>
            <OverLayer hasImage={hasImage}>
              <CamaraIcon />
              <Text type="H5" fontWeight="bold" fontFamily="bold">
                {title}
              </Text>
              <CamaraSubtitleText type="caption">{subtitle}</CamaraSubtitleText>
              <input
                type="file"
                accept="image/png, image/jpg, image/jpeg"
                onChange={handleFileChange}
                style={{ display: 'none' }}
                id="file-input"
                ref={inputRef}
              />
            </OverLayer>
          </ImageToShow>
          </CamaraContainer>
          </View>
          {hasImage && <View style={{ flex: 0.2 }}>
          <TouchableOpacity
                      onPress={() => {
                        handlePreviewPress()
                      }}
                      style={{
                        paddingLeft: 12,
                        paddingRight: 12,
                        borderRadius: 10,
                        borderWidth: 2,
                        height: '100%',
                        width: '100%',
                        justifyContent: 'center',
                        borderColor: 'transparent',
                        backgroundColor: colors.grisClaro,
                        alignItems: 'center',
                      }}
                    >
                      <EyeIcon width={32} height={32} />
                      <Headline5 style={{ textAlign: 'center' }}>{t('common.preview')}</Headline5>
                    </TouchableOpacity>            

          </View>}
                  </View>
                  <Modal
          isVisible={showModal}
          backdropOpacity={0.7}
          useNativeDriver
          useNativeDriverForBackdrop
          hideModalContentWhileAnimating
          onBackdropPress={handlePreviewPress}>
          <ModalContainer>
            <ModalHeader>
              <Text type="H5">{t('common.preview')}</Text>
              <TouchableOpacity onPress={handlePreviewPress}>
                <XSimpleIcon width={30} height={30} />
              </TouchableOpacity>
            </ModalHeader>
            <ImageAutoScale source={{ uri: url }} height={300} />
          </ModalContainer>
        </Modal>
    </>
  )
}
